import { ModelBase } from 'store/model-base';

export class CmsExtendedPromos extends ModelBase {
    public static storeName: string = 'cmsExtendedPromos';

    public promos: CmsExtendedPromo[];
    public savingsIcon: CmsMediaImage;
    public changeOrderStatement: CmsChangeOrderStatement;
    public cbmGeminiChangeOrderStatement: CmsChangeOrderStatement;
}
